'use client';

import { Box } from '@chakra-ui/react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { ReactComponent as ArrowBackwardCircle } from '@/app/_icons/ArrowBackwardCircleDark.svg';
import { ReactComponent as ArrowForwardCircle } from '@/app/_icons/ArrowForwardCircleDark.svg';

import Styles from './BlogList.module.scss';

export default function BlogListPagination({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) {
  const searchParams = useSearchParams();

  function getHref(page: number) {
    const newSearchParams = new URLSearchParams({
      ...Object.fromEntries(searchParams),
      page: page.toString(),
    });

    return `?${newSearchParams.toString()}`;
  }

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="end">
        <Box className={Styles.blogListPagination}>
          <span className="current-page">{currentPage}</span>
          <span className="separator">/</span>
          <span className="total-pages">{totalPages}</span>
        </Box>
        <Box className={Styles.blogListNavigation}>
          {currentPage > 1 ? (
            <Link
              aria-label="Previous page"
              className={Styles.blogListPrev}
              href={getHref(currentPage - 1)}
            >
              <ArrowBackwardCircle />
            </Link>
          ) : (
            <button
              aria-disabled="true"
              aria-label="Previous page disabled"
              disabled
              className={`${Styles.blogListPrev} ${Styles.disabled}`}
            >
              <ArrowBackwardCircle />
            </button>
          )}
          {currentPage < totalPages ? (
            <Link
              aria-label="Next page"
              className={Styles.blogListNext}
              href={getHref(currentPage + 1)}
            >
              <ArrowForwardCircle />
            </Link>
          ) : (
            <button
              aria-label="Next page disabled"
              disabled
              className={`${Styles.blogListNext} ${Styles.disabled}`}
            >
              <ArrowForwardCircle />
            </button>
          )}
        </Box>
      </Box>
    </>
  );
}
